import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Semanticpmpmvt7fldq2 as Semantic } from '../../models/Theme.mjs';
import { divkhq3vjih9fcw as div } from '../../models/data.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  over39z80ikqtn4zd as over,
  exit1izku02sy8o8o as exit,
  DropTargetDelegatej7xcw0yh1xmk as DropTargetDelegate,
} from '../DropTargetDelegate.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { DragData2helsigoeiabk as DragData } from '../../models/DragData.mjs';
import { toInt2q8uldh7sc951 as toInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.vdk_1.rdk_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.tdk_1.ydk_1(new (Move())($this.udk_1, tmp$ret$0), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var DragDropReordering$Delegate$drop$slambdaClass;
function DragDropReordering$Delegate$drop$slambda() {
  if (DragDropReordering$Delegate$drop$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $sourceIdx, this$1) {
        this.tdk_1 = this$0;
        this.udk_1 = $sourceIdx;
        this.vdk_1 = this$1;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DragDropReordering$Delegate$drop$slambdaClass = $;
  }
  return DragDropReordering$Delegate$drop$slambdaClass;
}
function DragDropReordering$Delegate$drop$slambda_0(this$0, $sourceIdx, this$1) {
  var i = new (DragDropReordering$Delegate$drop$slambda())(this$0, $sourceIdx, this$1);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var HalfGapClass;
function HalfGap() {
  if (HalfGapClass === VOID) {
    class $ extends Semantic() {
      static bdl() {
        HalfGap_instance = null;
        var $this = this.bd1('halfgap');
        HalfGap_instance = $this;
        return $this;
      }
      cd1(theme) {
        return this.ed1(theme, false, VOID, VOID, VOID, div(theme.hb0_1, 2));
      }
    }
    initMetadataForObject($, 'HalfGap');
    HalfGapClass = $;
  }
  return HalfGapClass;
}
var HalfGap_instance;
function HalfGap_getInstance() {
  if (HalfGap_instance === VOID)
    HalfGap().bdl();
  return HalfGap_instance;
}
var MoveClass;
function Move() {
  if (MoveClass === VOID) {
    class $ {
      constructor(start, end) {
        this.cdl_1 = start;
        this.ddl_1 = end;
      }
      toString() {
        return 'Move(start=' + this.cdl_1 + ', end=' + this.ddl_1 + ')';
      }
      hashCode() {
        var result = this.cdl_1;
        result = imul(result, 31) + this.ddl_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Move()))
          return false;
        if (!(this.cdl_1 === other.cdl_1))
          return false;
        if (!(this.ddl_1 === other.ddl_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Move');
    MoveClass = $;
  }
  return MoveClass;
}
var DelegateClass;
function Delegate() {
  if (DelegateClass === VOID) {
    class $ {
      constructor($outer, index) {
        this.sdk_1 = $outer;
        this.rdk_1 = index;
      }
      rd8(event) {
        var tmp0_safe_receiver = this.sdk_1.edl(event.lcy_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
          var this_0 = this.rdk_1.qah();
          var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
          var tmp_0;
          if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
            println('Not Ready');
            tmp_0 = false;
          } else {
            if (tmp0_subject instanceof InternalReactiveThrownException()) {
              _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
              println('Exception');
              tmp_0 = false;
            } else {
              if (tmp0_subject instanceof InternalReactiveWrapper()) {
                var tmp_1 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
                var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
                this.sdk_1.zdk_1.mam(new (Move())(tmp0_safe_receiver, it));
                tmp_0 = true;
              } else {
                var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
                this.sdk_1.zdk_1.mam(new (Move())(tmp0_safe_receiver, it_0));
                tmp_0 = true;
              }
            }
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      td8(event) {
        this.sdk_1.zdk_1.mam(null);
        return true;
      }
      ud8(event) {
        var tmp0_safe_receiver = this.sdk_1.edl(event.lcy_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          launch(this.sdk_1.wdk_1, VOID, VOID, DragDropReordering$Delegate$drop$slambda_0(this.sdk_1, tmp0_safe_receiver, this));
          this.sdk_1.zdk_1.mam(null);
          tmp = true;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
    }
    protoOf($).qd8 = over;
    protoOf($).sd8 = exit;
    initMetadataForClass($, 'Delegate', VOID, VOID, [DropTargetDelegate()]);
    DelegateClass = $;
  }
  return DelegateClass;
}
var DragDropReorderingClass;
function DragDropReordering() {
  if (DragDropReorderingClass === VOID) {
    class $ {
      constructor(scope, mimeType, reorder) {
        mimeType = mimeType === VOID ? 'application/kiteui-index' : mimeType;
        this.wdk_1 = scope;
        this.xdk_1 = mimeType;
        this.ydk_1 = reorder;
        this.zdk_1 = Signal().fak(null);
      }
      fdl(index) {
        return DragData().dcy('Source Index', this.xdk_1, index.toString());
      }
      edl(data) {
        var tmp0_safe_receiver = data.gi(this.xdk_1);
        return tmp0_safe_receiver == null ? null : toInt(tmp0_safe_receiver);
      }
    }
    initMetadataForClass($, 'DragDropReordering');
    DragDropReorderingClass = $;
  }
  return DragDropReorderingClass;
}
//region block: exports
export {
  Delegate as Delegate2igvowszj3trz,
  Move as Movepj4bxmsunu5w,
  DragDropReordering as DragDropReordering2of2svhx5wqie,
  HalfGap_getInstance as HalfGap_getInstance2pfkgmm8af0gl,
};
//endregion

//# sourceMappingURL=forEachReorderable.mjs.map
